import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { getOrders } from "./redux/actions/orders";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Line Chart",
    },
  },
};

const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "long",
  });
};

export default function LineChart() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const { orders } = useSelector((state) => state.orders);

  const months = orders.map((order) => formatDate(order.attributes.orderDate));

  const labels = [...new Set(months)];

  const data = {
    labels,
    datasets: [
      {
        label: "five",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fives)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "ten",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.tens)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "fifteen",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fifteens)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(0, 255, 0, 0.5)",
      },
      {
        label: "twenty five",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.twenty_fives)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 240, 0, 0.5)",
      },
      {
        label: "fifty",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fifties)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 128, 0, 0.5)",
      },
      {
        label: "hundred",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.hundreds)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(102, 102, 255,0.5)",
      },
    ],
  };

  return <Line options={options} data={data} />;
}
